/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { useAppSelector } from '@redux/index'
import { View } from './View'
import { BoxHeaderView } from './BoxHeaderView'

interface PropsType {
	title?: string
	showHeader?: false
	renderTitle?: React.ReactNode
	className?: string
	children?: React.ReactNode
	leftHeaderAccessory?: JSX.Element
	rightHeaderAccessory?: React.ReactNode
	backgroundColor?: string
}

export const BoxView = (props: PropsType) => {
	// redux state
	const backgroundColor: string = useAppSelector(state => state.config.backgroundColor)

	// variables
	const showHeader: boolean = props.showHeader ?? true

	return (
		<View
			css={[
				style,
				{ background: props.backgroundColor ? props.backgroundColor : backgroundColor },
			]}
			className={props.className ?? ''}
		>
			{showHeader ? (
				<BoxHeaderView
					title={props.title}
					renderTitle={props.renderTitle}
					leftHeaderAccessory={props.leftHeaderAccessory}
					rightHeaderAccessory={props.rightHeaderAccessory}
				/>
			) : null}
			<View className="boxChildrenView">{props.children}</View>
		</View>
	)
}

const style = css({
	minHeight: 'calc(100vh - 4rem)',
	height: 'calc(100vh - 4rem)',
	padding: '1rem',
	borderRadius: '5px',

	'.boxChildrenView': {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'flex-start',
		width: '100%',
		height: 'calc(100% - 3.5rem)',
		paddingTop: '0.5rem',
		overflow: 'auto',
	},

	'@media (max-width: 900px)': {
		position: 'relative',
		height: 'fit-content',
		minHeight: '100%',
		padding: 0,

		'.boxChildrenView': {
			height: 'fit-content',
		},
	},
})
